import { useTheme as muiUseTheme } from "@mui/system";

import { default as THEME } from "./theme";
import { GRID_SIZE } from "./grid";

export { default as BackpackThemeProvider } from "./ThemeProvider";
export { THEME, GRID_SIZE };
export { ResponsiveValue } from "./grid";
export type Theme = typeof THEME;

export const useTheme = () => muiUseTheme<Theme>();
